/*
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../utils/AuthUtils';
import ModalLoadingSpinner from '../common/layout/ModalLoadingSpinner';
import { LoginCallback } from '@okta/okta-react';

export type LoginCallbackErrorStatus = {
  loginError: boolean;
};

// This gets rendered when there is an error during the Okta login callback process
const CallbackErrorRedirect: React.FC<{ error: Error }> = () => {
  const history = useHistory();

  useEffect(() => {
    const errorStatus: LoginCallbackErrorStatus = { loginError: true };
    history.replace(LOGIN_ROUTE, errorStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

const CustomLoginCallback = () => (
  <LoginCallback errorComponent={CallbackErrorRedirect} loadingElement={<ModalLoadingSpinner />} />
);

export default CustomLoginCallback;
